import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid, Header, Label, Loader, Segment } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { toTitleCase } from '../../app/common/util';
import './style.css';

import CustomNavLink from '../nav/SideBar/component/CustomNavLink';

const mapState = state => ({
  auth: state.auth,
  async: state.async,
  isLoggedIn: (state.auth.isLoggedIn && state.auth.isLoggedIn.result) || false,
  payment: state.payment
});

class MobileHeader extends Component {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    async: PropTypes.object.isRequired,
    isLoggedIn: PropTypes.bool.isRequired,
    payment: PropTypes.object
  };

  state = {
    userProfileImage:
      'https://dmx246cm6p7k8.cloudfront.net/content/images/profile_avatar.png'
  };

  render() {
    // Destructure props
    const {
      async,
      auth: { profile },
      payment
    } = this.props;

    // Don't show the mobile header on login page
    if (window.location && window.location.pathname.split('/').indexOf('login') !== -1) {
      return null;
    }

    return (
      <div>
        <div id="mobile-header">
          <Segment basic>
            <Header.Content as="h2">
              <Grid>
                <Grid.Column width={3}>
                  <img
                    alt={'Profile Avatar'}
                    src="https://s.freecharge.in/mobile/images/avatar.png?v=9"
                    className="floatLeft"
                    style={{ marginRight: '10px' }}
                  />
                </Grid.Column>

                <Grid.Column width={10}>
                  <CustomNavLink to="profile">
                    {profile && toTitleCase(profile.name)}{' '}
                    {profile && toTitleCase(profile.lastName)}
                  </CustomNavLink>

                  <Header.Subheader as="span" className="email">
                    {profile && profile.email}
                    <Header.Subheader as="span" className="phone">
                      {profile && profile.mobileNo}
                    </Header.Subheader>
                  </Header.Subheader>
                </Grid.Column>
              </Grid>
            </Header.Content>

            <Grid>
              <Grid.Row>
                <Grid.Column width={8}>
                  <h2 className="totalBalance">
                    Balance{' '}
                    <span>
                      {payment.balance && payment.balance.totalBalance}
                    </span>
                    {/* <BalanceInfo payment={payment} iconWidth="11px" iconBrightness={3} /> */}
                    <Loader
                      active={
                        async.loading &&
                        !(payment.balance && payment.balance.totalBalance)
                      }
                      inline
                      size="small"
                    />
                    {!async.loading &&
                      !(payment.balance && payment.balance.totalBalance) && (
                        <Label basic color="red" size="large">
                          Server Error!
                        </Label>
                      )}
                  </h2>
                </Grid.Column>

                <Grid.Column width={8}>
                  <CustomNavLink to="cash" className="buttonAddMoney">
                    Add Money
                  </CustomNavLink>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Segment>
        </div>

        {this.props.children}
      </div>
    );
  }
}

export default connect(
  mapState
)(MobileHeader);
